
<template>
  <div class="attention" :class="{ isIosx: isIosx }">
    <van-sticky>
      <div class="attentionNav">
        <img
          class="navLeft"
          @click="prev()"
          src="./../../assets/school/backh.png"
        />
        <span class="navTitle">关注</span>
      </div>
    </van-sticky>
    <div class="attentionContent">
      <div v-if="dataList.length>0">
         <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="attentionItem"
            v-for="(item, index) in dataList"
            :key="index"
            @click="toLecturerDetail(item.lecturer_id)"
          >
            <img v-if="item.lecturer.head_pic" :src="item.lecturer.head_pic" class="img" />
            <img v-else src="./../../assets/school/defaultAvatar.png" class="img" />
            <div>
              <p class="title">{{ item.lecturer.name }}</p>
              <p class="dec">
                {{ item.lecturer.desc }}
              </p>
            </div>
            <img src="./../../assets/school/right.png" class="right" />
          </div>
        </van-list>
      </van-pull-refresh>
      </div>
      <div v-else class="noData">
        <img src="./../../assets/school/lecturerTip.png">
        <p>关注讲师不迷路</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isIosx: false,
      dataList: [],
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      refreshing: false,
    };
  },
  mounted() {
    this.isIosx = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.getData();
  },
  methods: {
    prev() {
      this.$router.go(-1);
    },
    // 获取数据
    getData() {
      this.$api
        .get("school/member/fans/list", {
          page: this.page, //类型：Number  必有字段  备注：1
          pageSize: this.pageSize, //类型：Number  必有字段  备注：10
        })
        .then((res) => {
          this.dataList = this.dataList.concat(res.list);
          this.refreshing = false;
          this.loading = false;
          if (this.dataList.length >= res.total) {
            // 数据全部加载完成
            this.finished = true;
          } else {
            this.finished = false;
          }
        });
    },
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.dataList = [];
      this.getData();
    },
    // 上拉加载
    onLoad() {
      this.page++;
      this.getData();
    },
    // 进入讲师详情
    toLecturerDetail(id) {
      this.$router.push({
        path: "/school/lecturerDetails",
        query: {
          id: id,
        },
      });
    },
  },
};
</script>

<style>
.attention {
  height: 100%;
  background: #f7f8fc;
  /* overflow: auto; */
}
.attentionNav {
  color: #404247;
  height: 22px;
  padding-top: 38px;
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 11px;
  background-color: #ffffff;
  position: relative;
}
.attentionNav .navLeft {
  position: absolute;
  left: 16px;
  width: 24px;
  height: 24px;
}
.attentionNav .navTitle {
  font-size: 17px;
  font-weight: 700;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
/* content */
.attentionContent {
  margin: 0 16px;
}
.attentionItem {
  background-color: #ffffff;
  margin-top: 16px;
  height: 64px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}
.attentionItem .img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.attentionItem > div {
  display: flex;
  flex-direction: column;
  margin: 0 8px;
  flex: 1;
}
.attentionItem > div .title {
  font-weight: 700;
  color: #404247;
  font-size: 15px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
.attentionItem > div .dec {
  font-weight: 400;
  color: #9ca1ad;
  font-size: 12px;
  line-height: 17px;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  /*! autoprefixer: off */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: normal;
  word-break: break-all;
  word-wrap: break-word;
}
.attentionItem .right {
  width: 12px;
  height: 12px;
}

.isIosx .attentionNav {
  padding-top: 44px;
}

.noData {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.noData img {
  width: 235px;
  height: 235px;
}
.noData p {
  margin-top: 24px;
  font-size: 14px;
  color: #9ca1ad;
}

.attention .van-list__finished-text {
  margin-top: 48px;
}
</style>